<template>
  <div class="main">
    <a-card :loading="spinning" style="border-radius: 20px;" :bordered="false">
      <div>
        <div>
          <div class="actions">
            <div @click="redirectUrl"
              style="font-size:20px;text-decoration: none;width:30%;line-height:30px;display:flex;cursor:pointer">
              <p>
                <a-icon style="font-size: 15px; margin-right: 8px;" type="arrow-left" />
              </p>
              <p>Go Back To Quotation </p>
            </div>
            <!-- <div>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="edit" class="mr-4">
                        Edit
                    </a-button>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div> -->
          </div>

          <h3 style="font-size: 28px; line-height: 45px">
            Quotation Details for #: {{ displayInvoiceId }}
          </h3>
        </div>

        <div v-show="orderDetails.statusLabel === 'Firmed' || orderDetails.statusLabel === 'Fulfilling'"
          style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
          <a-button @click="showFulfillmentModal"
            style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
            Create Fulfillment
          </a-button>
        </div>
        <a-row>
          <a-col :span="24">
            <div style="background: #fff; padding: 20px">
              <p style="color: #418a49">Shipping Address Details</p>
              <a-row :style="{ paddingTop: '1em' }" :gutter="42">
                <a-col :span="6">
                  <h4 :style="{ fontSize: '18px', color: '#333' }">
                    Retailer's Name:
                  </h4>
                  <p style="font-weight: medium">
                    {{ retailerDetails.name ? retailerDetails.name : "N/A" }}
                  </p>
                </a-col>
                <a-col :span="6">
                  <h4 :style="{ fontSize: '18px', color: '#333' }">
                    Retailer's Address:
                  </h4>
                  <p style="font-weight: medium">
                    {{
                    retailerDetails.address ? retailerDetails.address : "N/A"
                    }}
                  </p>
                </a-col>
                <a-col :span="6">
                  <h4 :style="{ fontSize: '18px', color: '#333' }">
                    Retailer's Phone Number:
                  </h4>
                  <p style="font-weight: medium">
                    {{
                    retailerDetails.phoneNumber
                    ? "+233" + retailerDetails.phoneNumber
                    : "N/A"
                    }}
                  </p>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <a-row :style="{ marginTop: '2em' }">
          <a-col :span="24">
            <div style="background: #fff">
              <p style="padding-left: 20px; color: #418a49; padding-top: 10px">
                Quotation Items:
              </p>
              <a-table :columns="columns" :data-source="tableData" :loading="tableLoading" :scroll="{ x: 1500, y: 600 }"
                :pagination="false" class="tableStyle">
                <template slot="action" slot-scope="order">
                  <a-dropdown>
                    <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon style="font-size: 25px" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="showConfirmOrderModal(order)">Confrim Product Line?</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click="showCancelOrderModal(order)">Cancel Order?</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>

                <template slot="status" slot-scope="data">
                  <div style="
                    display: flex;
                    padding-top: 4px;
                    justify-content: space-around;
                    background: #fff2d6;
                    width: 140px;
                    height: 27px;
                    border-radius: 30px;
                  " v-if="data === `UnConfirmed`">
                    <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                    <p style="font-size: 12px; color: #ffb102">{{ data }}</p>
                  </div>

                  <div style="
                    display: flex;
                    padding-top: 4px;
                    justify-content: space-around;
                    background: #418a49;
                    width: 140px;
                    height: 27px;
                    border-radius: 30px;
                  " v-if="data === `Confirmed`">
                    <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                    <p style="font-size: 12px; color: #fff">{{ data }}</p>
                  </div>
                  <div style="
                    display: flex;
                    padding-top: 4px;
                    justify-content: space-around;
                    background: #ff000073;
                    width: 140px;
                    height: 27px;
                    border-radius: 30px;
                  " v-if="data === `Cancelled`">
                    <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                    <p style="font-size: 12px; color: #fff">{{ data }}</p>
                  </div>
                </template>
              </a-table>
              <div style="
                display: flex;
                justify-content: flex-end;
                padding-top: 10px;
                font-size: 20px;
                padding-right: 20px;
              ">
                <p>
                  Total : Ksh
                  {{ displayToTalAmount ? displayToTalAmount : "0.00" }}
                </p>
              </div>
            </div>
          </a-col>
        </a-row>

        <a-modal class="modalStyle" :visible="addBackOrderVisible" :footer="null" @cancel="handleAddBackOrderCancel">
          <h3 style="
            display: flex;
            justify-content: center;
            font-weight: bolder;
            padding-top: 10px;
            padding-bottom: 30px;
          ">
            Add New Back Orders
          </h3>
          <div>
            <a-form-model ref="addBackOrderForm" :model="addBackOrderModel" :rules="rules">
              <a-row>
                <a-col :span="22" :offset="1">
                  <a-form-model-item label="Retailers" ref="retailerId" prop="retailerId">
                    <a-select v-model="addBackOrderModel.retailerId" placeholder="please select your retailer">
                      <a-select-option v-for="retailer in availableRetailers" :key="retailer.locationId"
                        v-bind:value="retailer.locationId">
                        {{ retailer.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="22" :offset="1">
                  <a-form-model-item label="Products" ref="retailerProductIds" prop="retailerProductIds">
                    <a-select mode="multiple" v-model="addBackOrderModel.retailerProductIds"
                      placeholder="please select your products">
                      <a-select-option v-for="product in availableClientProducts" :key="product.id">
                        {{ product.brandName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="22" :offset="1">
                  <a-form-model-item label="Notes" ref="notes" prop="notes">
                    <a-textarea v-model="addBackOrderModel.notes" placeholder="Enter notes...."
                      :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <div style="
                display: flex;
                justify-content: center;
                padding-bottom: 10px;
              ">
                <a-spin class="spinner" :spinning="loading" />
              </div>

              <a-form-model-item style="
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 40px;
              ">
                <a-button @click="handleAddBackOrderSubmit" style="
                  background: #418a49;
                  height: 59px;
                  color: #fff;
                  width: 263px;
                  border-radius: 5px;
                ">
                  Add Back Order
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </a-modal>
      </div>
      <div>
        <BackOrderFulfillments :backOrder="orderDetails" />
      </div>
      <!-- Create Fulfillment Model -->
      <a-modal class="modalStyle" :visible="createFullmentVisible" width="800px" :footer="null"
        @cancel="handleFullmentCancel">
        <a-spin :spinning="loading">
          <h3 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
            Create
            Fulfillment</h3>
          <create-fulfillment-form :data="data" @inventoryRequest="handleCreateFullment"></create-fulfillment-form>
        </a-spin>
      </a-modal>
    </a-card>
  </div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import XLSX from "xlsx";
import BackOrderFulfillments from "./tables/BackOrderFulfillments";
import CreateFulfillmentForm from './modal/CreateFulfillmentForm.vue'

const columns = [
  {
    title: "Product ID",
    width: 100,
    key: "id",
    dataIndex: "id",
  },
  {
    title: "Product Name",
    dataIndex: "productBrandName",
    key: "productBrandName",
    width: 180,
  },
  {
    title: "Category",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    width: 180,
  },
  {
    title: "Supplier",
    dataIndex: "productSupplierName",
    key: "productSupplierName",
    width: 180,
  },
  {
    title: "Cost Price(Ksh)",
    dataIndex: "costPrice",
    width: 150,
  },
  {
    title: "Selling Price(Ksh)",
    dataIndex: "unitPrice",
    key: "unitPrice",
    width: 150,
  },

  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
    width: 120,
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    width: 180
  },
  {
    title: "Line Total",
    dataIndex: "lineTotal",
    key: "lineTotal",
    width: 100,
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "BackOrdersDetails",
  components: { BackOrderFulfillments, CreateFulfillmentForm },
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      startDate: moment()
        .subtract(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: moment().add(1, "d").format("YYYY-MM-DD"),
      searchText: "",
      columns,
      product: {},
      tableData: [],
      availableRetailers: [],
      availableClientProducts: [],
      orderItemStatus: [],
      exportLoading: false,
      addBackOrderVisible: false,
      spinning: false,
      isOrderConfimed: Boolean,
      pagination: {
        pageSize: 20,
      },
      data: {},
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {},
      },
      orderDetails: {},
      addBackOrderModel: {
        retailerId: "",
        retailerProductIds: [],
        notes: "",
      },
      retailerDetails: {},
      productId: "",
      loading: false,
      tableLoading: false,
      createFullmentVisible: false,
      rules: {
        retailerId: [
          {
            required: true,
            message: "Please choose your option",
            trigger: "change",
          },
        ],
        retailerProductIds: [
          {
            required: true,
            message: "Please choose your options",
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            message: "Please enter your quantity",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^[1-9]\d*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        sellingPrice: [
          {
            required: true,
            message: "Please enter selling price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        purchasePrice: [
          {
            required: true,
            message: "Please enter purchase price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getBackOrder"]),
    displayInvoiceId() {
      return this.orderDetails.id;
    },
    disableButton() {
      return this.orderItemStatus.length === 0 ? true : false;
    },
    displayToTalAmount() {
      // console.log(" tableData  | ", this.tableData`);
      // console.log("in computed item |", this.newRequestInventoryform.request)
      const itemAmount = this.tableData.map(
        (item) =>
          parseFloat(item.action.unitPrice) * parseFloat(item.action.quantity)
      );
      // console.log("in each itemAmount |", itemAmount)
      const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
      // console.log("in computed totalAmt |", totalAmt)
      return totalAmt.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
  },
  methods: {
    ...mapActions([
      "getBackOrdersData",
      "getBackOrderById",
      "getRetailerAndProducts",
      "addBackOrder",
      "updateBackOrderLines",
      "getAllRetailers",
    ]),
    moment,

    showFulfillmentModal() {

      this.data = {
        id: this.orderDetails.id,
        data: this.tableData.map(product => ({
          productId: product.id,
          productName: product.productBrandName,
          quantity: product.quantity,
        }))
      }
      this.createFullmentVisible = true
    },
    redirectUrl() {
      this.$router.back();
    },
    handleFullmentCancel() {
      this.createFullmentVisible = false
    },

    async handleCreateFullment(data) {
      this.loading = true
      const response = await this.$store.dispatch("fulfillments/CreateBackOrderFulfillments", data);
      this.loading = false
      if (response.status == 200) {
        this.createFullmentVisible = false
        this.showSuccessAlert("Fulfillment Created Successfully")
        this.loadBackOrderData()
      } else {
        this.showErrorAlert(response.data.messages)
      }
    },

    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },
    exportExcell() {
      this.exportLoading = true;
      const dataToExport = [
        [
          "Purchased Order ID",
          "Supplier Name",
          "Total OrderValue",
          "Username",
          "Date Created",
        ],
      ];

      this.getPurchasedOrderReport(this.params).then(
        (response) => {
          this.exportLoading = false;

          // console.log('response in sales | ', response)
          if (response.status === 200) {
            let results = response.data.data;

            results.forEach((v) => {
              dataToExport.push([
                v.id,
                v.supplierName,
                v.totalOrderValue,
                v.userName,
                moment(v.createdAt).format("DD-MM-YYYY"),
              ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(
              wb,
              `Export-Purchased-Order-Report-${moment().format(
                "DD-MM-YYYY"
              )}.xlsx`
            );
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported");
          } else {
            this.exportLoading = false;
            // console.log("Error | ", response);
          }
        },
        (error) => {
          this.exportLoading = false;
          console.log("Error | ", error);
        }
      );
    },
    showAddBackOrderModal() {
      this.addBackOrderVisible = true;
    },
    handleAddBackOrderCancel() {
      this.addBackOrderVisible = false;
    },
    orderOnChange(checked) {
      this.isOrderConfimed = checked;
    },
    async showConfirmOrderModal(order) {
      this.spinning = true;
      const request = {
        backOrderId: order.backOrderId,
        backOrderLineId: order.id,
        data: {
          status: 1,
        },
      };
      const response = await this.updateBackOrderLines(request);
      this.spinning = false;
      if (response.status === 200) {
        this.loadBackOrderData();
        this.showSuccessAlert(`Back Order Confirmed Successfully`);
      } else {
        this.spinning = false;
        // console.log("Error | ", response);
      }
    },
    async showCancelOrderModal(order) {
      this.spinning = true;
      const request = {
        backOrderId: order.backOrderId,
        backOrderLineId: order.id,
        data: {
          status: 2,
        },
      };
      const response = await this.updateBackOrderLines(request);
      this.spinning = false;
      if (response.status === 200) {
        this.loadBackOrderData();
        this.showSuccessAlert(`Back Order Cancelled Successfully`);
      } else {
        this.spinning = false;
        // console.log("Error | ", response);
      }
    },
    // saveOrder(){
    //     console.log("orderItemStatus | ", this.orderItemStatus)
    //     if(this.orderItemStatus.length > 0){
    //         this.spinning = true;
    //         this.orderItemStatus.forEach(orderItem => {
    //             const request = {
    //                 backOrderId: orderItem.order.backOrderId,
    //                 backOrderLineId: orderItem.order.id,
    //                 data:{
    //                     status: orderItem.status
    //                 }
    //             }
    //             this.updateBackOrderLines(request)
    //         })

    //         setTimeout(() => {
    //             this.orderItemStatus = [];
    //             this.spinning = false;
    //             this.showSuccessAlert("Orders Saved Successfully")
    //             this.loadBackOrderData();
    //         }, 3000); //3 secs

    //     }
    // },
    async getRetailerDetails(retailerCenter) {
      const response = await this.getAllRetailers();
      if (response.status === 200) {
        this.retailerDetails = response.data.data.find(
          (retailer) =>
            retailer.locationId === retailerCenter.data.destinationLocationId
        );
      } else {
        // console.log("Error | ", response);
      }
    },
    async loadBackOrderData() {
      this.tableLoading = true;
      const request = {
        id: this.orderDetails.id,
      };
      const response = await this.getBackOrderById(request);

      if (response.status === 200) {
        this.tableLoading = false;
        this.tableData = response.data.backOrderLines.map((order) => ({
          key: order.id,
          id: order.productId,
          productBrandName: order.productBrandName,
          productCategoryName: order.productCategoryName ? order.productCategoryName : "N/A",
          productSupplierName: order.productSupplierName ? order.productSupplierName : "N/A",
          costPrice: order.costPrice
            ? order.costPrice.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })
            : "N/A",
          unitPrice: order.unitPrice
            ? order.unitPrice.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })
            : "N/A",
          quantity: order.quantity,
          status: order.statusLabel,
          lineTotal: (order.unitPrice * order.quantity).toLocaleString(
            undefined,
            { minimumFractionDigits: 2 }
          ),
          action: order,
        }));
        this.getRetailerDetails(response);
      } else {
        this.tableLoading = false;
        // console.log("Error | ", response);
      }
    },
    handleAddBackOrderSubmit() {
      this.$refs.addBackOrderForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let productQuantity = {};

          this.availableClientProducts.some((product) => {
            if (
              this.addBackOrderModel.retailerProductIds.includes(product.id)
            ) {
              productQuantity[product.id] = product.unitQuantity;
            }
          });
          const request = {
            sourceLocationId: parseInt(process.env.VUE_APP_SOURCE_LOCATION_ID),
            destinationLocationId: this.addBackOrderModel.retailerId,
            productAndQuantity: productQuantity,
            notes: this.addBackOrderModel.notes,
          };

          this.addBackOrder(request).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.loadBackOrdersData();
                this.showSuccessAlert("New Back Order Created Successfully");
                this.$refs.addBackOrderForm.resetFields();
                this.addBackOrderVisible = false;
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
  created() {
    if (this.getBackOrder) {
      this.orderDetails = this.getBackOrder;
      // console.log("orderDetails | ", this.orderDetails)
      this.loadBackOrderData();
    }
  },
};
</script>

<style scoped>
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

a {
  color: #418a49;
}

a:hover {
  color: #418a49;
}

.ant-switch-checked {
  background-color: #418a49;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

/* button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
} */

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.tableStyle >>> .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #26A246;
    color: #fff;
  
}


.tableStyle >>> .ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle >>> .ant-table-header  {
    background: #fff !important;
}
</style>